import { Injectable } from '@angular/core'
import { UserInfo } from './api.service'

@Injectable({
    providedIn: 'root',
})
export class VirtualVisitService {
    constructor() {}

    canSelectVirtualVisit(userInfo: UserInfo): boolean {
        return !!userInfo.accountType && ['FABRICATOR', 'RETAIL', 'DESIGNER'].includes(userInfo.accountType) && ['US','CA','BR'].includes(userInfo.accountCountry || '')
    }

    private b64(str: string | null | undefined): string {
        if(!str) return ''
        return btoa(unescape(encodeURIComponent(str)))
    }

    goToVirtualVisit(userInfo: UserInfo) {
        const accountName = userInfo.accountName
        const firstName = userInfo.firstName
        const phone = userInfo.accountPhone
        const email = userInfo.email
        const contactId = userInfo.salesforceContactId

        const url = `https://www.cosentino.com/landings-usa/appointment/?accountName=${this.b64(accountName)}&firstName=${this.b64(firstName)}&phone=${this.b64(
            phone
        )}&email=${this.b64(email)}&contactId=${contactId}`

        window.open(url, '_blank')
    }

}
